//import qs from 'querystring';
import queryString from 'query-string';

const qsSimple = require('qs');

import { Observable } from 'rxjs';
import {
    setCompanyData,
    setCompanyDepartments,
    setCompanyOrgChartData,
    setCompanyPositionsArray,
    setPositionInfo,
} from '../reduxStore/actions/flowActions';
import { store } from '../reduxStore/store';
import { URLS } from './API_CONSTANTS';
import { axiosInstance } from './axiosInstance';
import { positionInfoDefault } from "../reduxStore/reducers/default/flowDefault";
// for all api from collection that involves company internal setup (as company group policy- folders Company/ positions/ departments )
export const getCompanyDetails = (customID = null, disableRefresh = false) => {
    const {
        companyData: { id: companyId },
    } = store.getState().flowReducer;
    const last_access_token = store.getState().authReducer?.sessionSettings?.last_access_token ?? null;
    const config = {
        ...URLS.company.getCompanyDetails(last_access_token, customID ?? companyId),
        handlerEnabled: true,
    };

    return new Observable(subscriber =>
        axiosInstance(config)
            .then((response) => {
                if (response?.status === 200 && response?.data && response?.data?.data) {
                    if(!disableRefresh) store.dispatch(setCompanyData({ ...response?.data?.data }));
                    subscriber.next(response?.data?.data);
                    subscriber.complete();
                }
            })
            .catch((error) => {
                subscriber.error(error);
            })
    );
};
export const getAllCompanies = (page, per_page, filters={}) => {
    const last_access_token = store.getState().authReducer?.sessionSettings?.last_access_token ?? null;

    const queryParams = {
        per_page: per_page,
        page: page,
        ...filters,
    };

    const cleanParams = params =>
        Object.fromEntries(Object.entries(params).filter(([_, v]) => v != null));

    const cleanedParams = cleanParams(queryParams);

    const params = queryString.stringify(cleanedParams, {
        skipNull: true,
        skipEmptyString: true,
    });
    const config = {
        ...URLS.company.getCompanies(last_access_token, params),
        handlerEnabled: true,
    };

    return new Observable(subscriber =>
        axiosInstance(config)
            .then((response) => {
                if (response?.status === 200 && response?.data && response?.data?.data) {
                    subscriber.next(response?.data);
                    subscriber.complete();
                }
            })
            .catch((error) => {
                subscriber.error(error);
            })
    );
};

export const exportCompaniesCSV = (filters={}) => {
    const last_access_token = store.getState().authReducer?.sessionSettings?.last_access_token ?? null;

    const queryParams = {
        ...filters,
    };

    const cleanParams = params =>
        Object.fromEntries(Object.entries(params).filter(([_, v]) => v != null));

    const cleanedParams = cleanParams(queryParams);

    const params = queryString.stringify(cleanedParams, {
        skipNull: true,
        skipEmptyString: true,
    });
    const config = {
        ...URLS.company.exportCompaniesCSV(last_access_token, params),
        handlerEnabled: true,
    };

    return new Observable(subscriber =>
        axiosInstance(config)
            .then((response) => {
                if (response?.status === 200 && response?.data) {
                    subscriber.next(response?.data);
                    subscriber.complete();
                }
            })
            .catch((error) => {
                subscriber.error(error);
            })
    );
};

export const getAllCompanyPositionsAsArray = (has_users_only = false) => {
    const {
        sessionSettings: {last_access_token},
    } = store.getState().authReducer;
    const config = {
        ...URLS.positions.getAllPositionsAsArray(last_access_token, has_users_only ? "?has_users_only=true" : ""),
        handlerEnabled: true,
    };

    return new Observable(subscriber =>
        axiosInstance(config)
            .then((response) => {
                if (response?.status === 200 && response?.data && response?.data?.data) {
                    const posi = [
                        ...(response?.data?.data?.map(i => ({
                            label: i.name,
                            value: i.id,
                        })) ?? []),
                    ].sort((a, b) => (a?.label?.toUpperCase() < b?.label?.toUpperCase() ? -1 : a?.label?.toUpperCase() > b?.label?.toUpperCase() ? 1 : 0));

                    store.dispatch(setCompanyPositionsArray([{ label: 'None of the above', value: '0' }, ...posi]));
                    subscriber.next(posi);
                    subscriber.complete();
                }
            })
            .catch((error) => {
                subscriber.error(error);
            })
    );
};

export const getInvitableCompanyPositionsAsArray = () => {
    const last_access_token = store.getState().authReducer?.sessionSettings?.last_access_token ?? null;
    const config = {
        ...URLS.positions.getInvitablePositionsAsArray(last_access_token),
        handlerEnabled: true,
    };

    return new Observable(subscriber =>
        axiosInstance(config)
            .then((response) => {
                if (response?.status === 200 && response?.data && response?.data?.data) {
                    const posi = [
                        ...(response?.data?.data?.map(i => ({
                            label: i.name,
                            value: i.id,
                        })) ?? []),
                    ].sort((a, b) => (a?.label?.toUpperCase() < b?.label?.toUpperCase() ? -1 : a?.label?.toUpperCase() > b?.label?.toUpperCase() ? 1 : 0));

                    subscriber.next([{ label: 'None of the above', value: '0' }, ...posi]);
                    subscriber.complete();
                }
            })
            .catch((error) => {
                subscriber.error(error);
            })
    );
};
export const setCompanyLogo = (logoFile) => {
    const {
        companyData: { id: companyId },
    } = store.getState().flowReducer;

    const last_access_token = store.getState().authReducer?.sessionSettings?.last_access_token ?? null;
    const data = new FormData();

    data.append('logo', logoFile);
    const config = {
        ...URLS.company.updateCompanyLogo(last_access_token, companyId),
        data: data,
        handlerEnabled: true,
    };

    return new Observable(subscriber =>
        axiosInstance(config)
            .then((response) => {
                if (response?.status === 200 && response?.data) {
                    store.dispatch(setCompanyData({ logo: (response?.data?.data?.logo + '?t=' + new Date().getTime()).toString() }));
                    subscriber.next(response.data);
                    subscriber.complete();
                }
            })
            .catch((error) => {
                subscriber.error(error);
            })
    );
};

export const createCompanyForUser = (companyData) => {
    const last_access_token = store.getState().authReducer?.sessionSettings?.last_access_token ?? null;
    const config = {
        ...URLS.company.createCompanyForUser(last_access_token),
        data: companyData,
        handlerEnabled: true,
        forwardAllErrors: true,
    };

    return new Observable(subscriber =>
        axiosInstance(config)
            .then((response) => {
                if (response?.status === 201 && response?.data) {
                    subscriber.next(response.data.data);
                    subscriber.complete();
                }
            })
            .catch((error) => {
                subscriber.error(error);
            })
    );
};

export const setCompanyDetails = (companyData, autoSave = true) => {
    const {
        companyData: { id: companyId },
    } = store.getState().flowReducer;

    const last_access_token = store.getState().authReducer?.sessionSettings?.last_access_token ?? null;
    const data = qsSimple.stringify(companyData);
    const config = {
        ...URLS.company.updateCompanyDetails(last_access_token, companyId),
        data: companyData,
        handlerEnabled: true,
        forwardAllErrors: true,
    };

    return new Observable(subscriber =>
        axiosInstance(config)
            .then((response) => {
                if (response?.status === 200 && response?.data) {
                    if(autoSave) store.dispatch(setCompanyData({ ...response?.data?.data }));
                    subscriber.next(response.data.data);
                    subscriber.complete();
                }
            })
            .catch((error) => {
                subscriber.error(error);
            })
    );
};

export const getCompanySMTPProvider = () => {
    const last_access_token = store.getState().authReducer?.sessionSettings?.last_access_token ?? null;
    const config = {
        ...URLS.company.getCompanySMTPProvider(last_access_token),
        handlerEnabled: true,
    };

    return new Observable(subscriber =>
        axiosInstance(config)
            .then((response) => {
                if (response?.status === 200 && response?.data && response?.data?.data) {
                    subscriber.next(response?.data?.data);
                    subscriber.complete();
                }
            })
            .catch((error) => {
                subscriber.error(error);
            })
    );
};

export const setCompanySMTPProvider = (customMailData) => {
    const data = {
        mail_configuration: customMailData,
    };

    const last_access_token = store.getState().authReducer?.sessionSettings?.last_access_token ?? null;

    const config = {
        ...URLS.company.updateCompanySMTPProvider(last_access_token),
        data: data,
        handlerEnabled: true,
        forwardAllErrors: true,
    };

    return new Observable(subscriber =>
        axiosInstance(config)
            .then((response) => {
                if ((response?.status === 200 || response?.status === 201) && response?.data) {
                    subscriber.next(response.data.data);
                    subscriber.complete();
                }
            })
            .catch((error) => {
                subscriber.error(error);
            })
    );
};

export const testCompanySMTPProvider = (customMailData) => {
    const data = {
        mail_configuration: customMailData,
    };

    const last_access_token = store.getState().authReducer?.sessionSettings?.last_access_token ?? null;

    const config = {
        ...URLS.company.testCompanySMTPProvider(last_access_token),
        data: data,
        handlerEnabled: true,
        forwardAllErrors: true,
    };

    return new Observable(subscriber =>
        axiosInstance(config)
            .then((response) => {
                if ((response?.status === 200 || response?.status === 201) && response?.data) {
                    subscriber.next(response.data.data);
                    subscriber.complete();
                }
            })
            .catch((error) => {
                subscriber.error(error);
            })
    );
};

export const sendOnboardingComplete = () => {
    const {
        companyData: { id: companyId },
    } = store.getState().flowReducer;

    const last_access_token = store.getState().authReducer?.sessionSettings?.last_access_token ?? null;
    const config = {
        ...URLS.company.completeOnBoarding(last_access_token, companyId),
        handlerEnabled: true,
    };

    return new Observable(subscriber =>
        axiosInstance(config)
            .then((response) => {
                if (response?.status === 200 && response?.data) {
                    store.dispatch(setCompanyData({ ...response?.data?.data, onboarding_status: true }));
                    subscriber.next(response?.data?.data);
                    subscriber.complete();
                }
            })
            .catch((error) => {
                subscriber.error(error);
            })
    );
};
export const getCompanyDepartments = () => {
    const last_access_token = store.getState().authReducer?.sessionSettings?.last_access_token ?? null;

    const config = {
        ...URLS.departments.getAllDepartments(last_access_token),
        handlerEnabled: true,
    };

    return new Observable(subscriber =>
        axiosInstance(config)
            .then((response) => {
                if (response?.status == 200 && response?.data && response?.data?.data) {
                    store.dispatch(setCompanyDepartments(response.data.data?.map(i => ({ label: i.name, value: i.id }))));
                    subscriber.next(response.data.data);
                    subscriber.complete();
                }
            })
            .catch((error) => {
                subscriber.error(error);
            })
    );
};
export const createNewCompanyDepartment = (ndValue, render_index, color) => {
    const last_access_token = store.getState().authReducer?.sessionSettings?.last_access_token ?? null;
    const data = new FormData();

    data.append('name', ndValue);
    data.append('render_index', render_index);
    data.append('color', color);
    const defaultConfig = { ...URLS.departments.createNewDepartment(last_access_token) };
    const config = {
        ...defaultConfig,
        headers: { ...defaultConfig.headers },
        data: data,
        handlerEnabled: true,
        refreshOrgChart: true,
    };

    return new Observable(subscriber =>
        axiosInstance(config)
            .then((response) => {
                if (response?.status == 200 && response?.data && response?.data?.data) {
                    // store.dispatch(someAction(payload));
                    subscriber.next(response.data.data);
                    subscriber.complete();
                }
            })
            .catch((error) => {
                subscriber.error(error);
            })
    );
};
export const updateCompanyDepartment = (ndValue, depId, color) => {
    const last_access_token = store.getState().authReducer?.sessionSettings?.last_access_token ?? null;
    const data = qsSimple.stringify({ name: ndValue, color: color });
    const defaultConfig = { ...URLS.departments.updateDepartmentById(last_access_token, depId) };
    const config = {
        ...defaultConfig,
        headers: { ...defaultConfig.headers },
        data: data,
        handlerEnabled: true,
        refreshOrgChart: true,
    };

    return new Observable(subscriber =>
        axiosInstance(config)
            .then((response) => {
                if (response?.status === 200 && response?.data && response?.data?.data) {
                    // store.dispatch(someAction(payload));
                    subscriber.next(response.data.data);
                    subscriber.complete();
                }
            })
            .catch((error) => {
                subscriber.error(error);
            })
    );
};
export const updateCompanyDepartmentsOrder = (depOrderArray) => {
    const last_access_token = store.getState().authReducer?.sessionSettings?.last_access_token ?? null;

    var data = JSON.stringify(depOrderArray);
    const defaultConfig = { ...URLS.departments.updateDepartmentsOrder(last_access_token) };
    const config = {
        ...defaultConfig,
        headers: { ...defaultConfig.headers },
        data: data,
        handlerEnabled: true,
        refreshOrgChart: true,
    };

    return new Observable(subscriber =>
        axiosInstance(config)
            .then((response) => {
                if (response?.status == 200 && response?.data && response?.data?.data) {
                    const newOrdered = response.data.data?.sort((a, b) =>
                        (a.render_index < b.render_index ? -1 : a.render_index > b.render_index ? 1 : 0));

                    subscriber.next(newOrdered);
                    subscriber.complete();
                }
            })
            .catch((error) => {
                subscriber.error(error);
            })
    );
};
export const deleteCompanyDepartment = (department) => {
    const last_access_token = store.getState().authReducer?.sessionSettings?.last_access_token ?? null;
    var data = new FormData();

    data.append('name', department.name);
    const defaultConfig = { ...URLS.departments.deleteDepartment(last_access_token, department.id) };
    const config = {
        ...defaultConfig,
        headers: { ...defaultConfig.headers },
        data: data,
        handlerEnabled: true,
        refreshOrgChart: true,
    };

    return new Observable(subscriber =>
        axiosInstance(config)
            .then((response) => {
                if (response?.status === 200 && response?.data) {
                    // store.dispatch(someAction(payload));
                    subscriber.next(response.data);
                    subscriber.complete();
                }
            })
            .catch((error) => {
                subscriber.error(error);
            })
    );
};
export const getCompanyOrgChartPositions = (groupChart=false) => {
    const last_access_token = store.getState().authReducer?.sessionSettings?.last_access_token ?? null;
    const config = {
        ...URLS.positions.getPositionsOrgChart(last_access_token),
        handlerEnabled: true,
    };

    return new Observable(subscriber =>
        axiosInstance(config)
            .then((response) => {
                if (response?.status === 200 && response?.data && response?.data?.data) {
                    if(groupChart){
                        const res={"id":"9ac66d70-34c2-42f7-aab9-8898ddafd762","name":"Powell Family Office","sub_name":"Holding Company","is_managerial":true,"is_department_root":false,"is_managed_by_current_user":true,"is_protected":true,"parent":null,"department":null,"users":[{"id":"80f5548d-7750-11ef-ad1f-0affc3c4038b","user_id":"9ac66d8a-e4d0-408c-bcb4-71754f3fced4","email":"gabriel.filip+123aabb@wesrom.com","first_name":"Gabriel","last_name":"Filip","timezone":"Pacific/Rarotonga","photo":null,"is_active":1,"is_admin":true,"user_type":"admin"},{"id":"80f5ad6d-7750-11ef-ad1f-0affc3c4038b","user_id":"9ae524de-7945-4f2d-8ad2-e89705cde770","email":"gabriel.filip+non+admin@wesrom.com","first_name":"Gabriel","last_name":"Non-admin","timezone":"Europe/Bucharest","photo":null,"is_active":1,"is_admin":true,"user_type":"admin"}],"shared_users":[],"children":[{"id":"9ac66d70-4322-4a6a-bcee-c6b2e69f93cd","name":"Powell Family Office","sub_name":"Holding Company","is_managerial":true,"is_department_root":true,"is_managed_by_current_user":true,"is_protected":true,"parent":{"id":"9ac66d70-34c2-42f7-aab9-8898ddafd762","name":"Powell Family Office"},"department":null,"users":[{"id":"80f5ad6d-7750-11ef-ad1f-0affc3c4038b","user_id":"9ae524de-7945-4f2d-8ad2-e89705cde770","email":"gabriel.filip+non+admin@wesrom.com","first_name":"Gabriel","last_name":"Non-admin","timezone":"Europe/Bucharest","photo":null,"is_active":1,"is_admin":true,"user_type":"admin"}],"shared_users":[],"children":[{"id":"9ac66d70-b931-4eda-a9e3-7ffc1f7db846","name":"Laughlin Black","sub_name":"Incorporation & Asset Protection","is_managerial":true,"is_department_root":false,"is_managed_by_current_user":true,"is_protected":false,"parent":{"id":"9ac66d70-4322-4a6a-bcee-c6b2e69f93cd","name":"General Manager"},"department":{"id":"9ac66d70-b3ff-4c36-b409-553d1d827d88","name":"Professional Services","users_count":3,"render_index":0,"position":1,"color":"#EB5757"},"users":[{"id":"80f5548d-7750-11ef-ad1f-0affc3c4038b","user_id":"9ac66d8a-e4d0-408c-bcb4-71754f3fced4","email":"gabriel.filip+123aabb@wesrom.com","first_name":"Gabriel","last_name":"Filip","timezone":"Pacific/Rarotonga","photo":null,"is_active":1,"is_admin":true,"user_type":"admin"}],"shared_users":[],"children":[{"id":"9ae52b3d-8996-4e5e-b060-42c4c9bf869c","name":"Alvanda Corporation SRL","sub_name":"Business Management SaaS","is_managerial":false,"is_department_root":false,"is_managed_by_current_user":true,"is_protected":false,"parent":{"id":"9ac66d70-b931-4eda-a9e3-7ffc1f7db846","name":"Laughlin Black"},"department":{"id":"9ac66d70-b3ff-4c36-b409-553d1d827d88","name":"Professional Services","users_count":3,"render_index":0,"position":1,"color":"#EB5757"},"users":[{"id":"80f5ade5-7750-11ef-ad1f-0affc3c4038b","user_id":"9ae52bb3-72db-45ce-bd9c-786ef684e0ba","email":"gabriel.filip+non+managerial@wesrom.com","first_name":"Gabriel","last_name":"Non-managerial","timezone":"Europe/Bucharest","photo":null,"is_active":1,"is_admin":false,"user_type":"manager"}],"shared_users":[],"children":[]},{"id":"9bd8a211-f4e6-4099-a67b-d4e2352658d7","name":"Wesrom Corporation SRL","sub_name":"Software Development","is_managerial":true,"is_department_root":false,"is_managed_by_current_user":true,"is_protected":false,"parent":{"id":"9ac66d70-b931-4eda-a9e3-7ffc1f7db846","name":"Laughlin Black"},"department":{"id":"9ac66d70-b3ff-4c36-b409-553d1d827d88","name":"Professional Services","users_count":3,"render_index":0,"position":1,"color":"#EB5757"},"users":[],"shared_users":[],"children":[{"id":"9c15226e-ac7a-4675-9227-2a0090fc4733","name":"Wesrom LLC","sub_name":"Digital Marketing","is_managerial":false,"is_department_root":false,"is_managed_by_current_user":true,"is_protected":false,"parent":{"id":"9bd8a211-f4e6-4099-a67b-d4e2352658d7","name":"Wesrom Corporation SRL"},"department":{"id":"9ac66d70-b3ff-4c36-b409-553d1d827d88","name":"Professional Services","users_count":3,"render_index":0,"position":1,"color":"#EB5757"},"users":[],"shared_users":[],"children":[]}]},{"id":"9bfb02aa-d292-4915-8361-085165f05e43","name":"Alvanda, Inc.","sub_name":"SaaS Reseller","is_managerial":false,"is_department_root":false,"is_managed_by_current_user":true,"is_protected":false,"parent":{"id":"9ac66d70-b931-4eda-a9e3-7ffc1f7db846","name":"Laughlin Black"},"department":{"id":"9ac66d70-b3ff-4c36-b409-553d1d827d88","name":"Professional Services","users_count":3,"render_index":0,"position":1,"color":"#EB5757"},"users":[],"shared_users":[],"children":[]}]},{"id":"9ac66d70-de80-4a66-93f6-9191aa9f98d3","name":"Brehon Energy, Inc.","sub_name":"Energy Distribution","is_managerial":true,"is_department_root":false,"is_managed_by_current_user":true,"is_protected":false,"parent":{"id":"9ac66d70-4322-4a6a-bcee-c6b2e69f93cd","name":"Powell Family Office"},"department":{"id":"9ac66d70-d806-4731-90d6-014d75f319f7","name":"Energy","users_count":0,"render_index":1,"position":2,"color":"#219653"},"users":[],"shared_users":[],"children":[{"id":"9c1521c8-c2d3-4076-bf5c-8c4aa49a1e4b","name":"Brehon Transmissions, Inc.","sub_name":"Energy Transmission","is_managerial":false,"is_department_root":false,"is_managed_by_current_user":true,"is_protected":false,"parent":{"id":"9ac66d70-de80-4a66-93f6-9191aa9f98d3","name":"Brehon Energy, Inc."},"department":{"id":"9ac66d70-d806-4731-90d6-014d75f319f7","name":"Energy","users_count":0,"render_index":1,"position":2,"color":"#219653"},"users":[],"shared_users":[],"children":[]}]},{"id":"9ac66d71-095a-40e7-b6df-85cc7e318c82","name":"Powell CRE, LLC","sub_name":"Commercial Real Estate","is_managerial":true,"is_department_root":true,"is_managed_by_current_user":true,"is_protected":false,"parent":{"id":"9ac66d70-4322-4a6a-bcee-c6b2e69f93cd","name":"Powell Family Office"},"department":{"id":"9ac66d71-03f1-4e9b-97b6-01e58442b6de","name":"Real Estate","users_count":0,"render_index":2,"position":3,"color":"#F2994A"},"users":[],"shared_users":[],"children":[]}]}]};

                        store.dispatch(setCompanyOrgChartData(res));
                        subscriber.next(res);
                    }else {
                        store.dispatch(setCompanyOrgChartData(response?.data?.data));
                        subscriber.next(response.data.data);
                    }
                    subscriber.complete();
                }
            })
            .catch((error) => {
                subscriber.error(error);
            })
    );
};

export const importInvitationsFromExcelFile = (excelFile) => {
    const last_access_token = store.getState().authReducer?.sessionSettings?.last_access_token ?? null;
    const data = new FormData();

    data.append('file', excelFile);

    const config = {
        ...URLS.invitations.importInvitation(last_access_token, data),
        handlerEnabled: true,
    };

    return new Observable(subscriber =>
        axiosInstance(config)
            .then((response) => {
                if (response?.status === 200 && response?.data && response?.data?.data) {
                    subscriber.next(response.data.data);
                    subscriber.complete();
                }
            })
            .catch((error) => {
                subscriber.error(error);
            })
    );
};
export const createInvitation = (invitationData) => {
    const last_access_token = store.getState().authReducer?.sessionSettings?.last_access_token ?? null;
    const data = new FormData();

    data.append('email', invitationData.email);
    data.append('first_name', invitationData.first_name);
    data.append('last_name', invitationData.last_name);
    if (invitationData.position_id && invitationData.position_id !== "0") data.append('position_id', invitationData.position_id);
    const config = {
        ...URLS.invitations.createInvitation(last_access_token, data),
        handlerEnabled: true,
        forwardAllErrors: true,
    };

    return new Observable(subscriber =>
        axiosInstance(config)
            .then((response) => {
                if (response?.data && response?.data?.data) {
                    const { first_name, last_name, email, position_id } = response.data.data;

                    // store.dispatch(setCompanyOrgChartData(response?.data?.data));
                    subscriber.next({ first_name, last_name, email, position_id });
                    subscriber.complete();
                }
            })
            .catch((error) => {
                subscriber.error(error);
            })
    );
};
export const getSentInvitations = (page, sort, group_id = null) => {
    const last_access_token = store.getState().authReducer?.sessionSettings?.last_access_token ?? null;

    const query = queryString.stringify(
        { per_page: 10, page: page, dir: sort.order, sort_by: sort.type, ...(group_id ? { group_id } : {}) },
        {
            skipNull: true,
            skipEmptyString: true,
        }
    );

    const config = {
        ...URLS.invitations.getInvitations(last_access_token, query),
        handlerEnabled: true,
        forwardAllErrors: true,
    };

    return new Observable(subscriber =>
        axiosInstance(config)
            .then((response) => {
                if (response?.data && response?.data?.data) {
                    subscriber.next(response.data);
                    subscriber.complete();
                }
            })
            .catch((error) => {
                subscriber.error(error);
            })
    );
};
export const closeInvitationById = (invitation_id) => {
    const last_access_token = store.getState().authReducer?.sessionSettings?.last_access_token ?? null;

    const config = {
        ...URLS.invitations.deleteInvitationById(last_access_token, invitation_id),
        handlerEnabled: true,
        forwardAllErrors: true,
    };

    return new Observable(subscriber =>
        axiosInstance(config)
            .then((response) => {
                if (response?.data) {
                    subscriber.next(response.data);
                    subscriber.complete();
                }
            })
            .catch((error) => {
                subscriber.error(error);
            })
    );
};
export const resendInvitationById = (invitation_id) => {
    const last_access_token = store.getState().authReducer?.sessionSettings?.last_access_token ?? null;

    const config = {
        ...URLS.invitations.resendAnInvitation(last_access_token, invitation_id),
        handlerEnabled: true,
        forwardAllErrors: true,
    };

    return new Observable(subscriber =>
        axiosInstance(config)
            .then((response) => {
                if (response?.data) {
                    subscriber.next(response.data);
                    subscriber.complete();
                }
            })
            .catch((error) => {
                subscriber.error(error);
            })
    );
};
export const getAllCompanyDepartmentPositions = (department) => {
    const last_access_token = store.getState().authReducer?.sessionSettings?.last_access_token ?? null;
    const defaultConfig = { ...URLS.departments.getAllDepartmentPositions(last_access_token, department.id) };
    const config = {
        ...defaultConfig,
        headers: { ...defaultConfig.headers },
        handlerEnabled: true,
    };

    return new Observable(subscriber =>
        axiosInstance(config)
            .then((response) => {
                if (response?.status == 200 && response?.data) {
                    // store.dispatch(someAction(payload));
                    subscriber.next(response.data);
                    subscriber.complete();
                }
            })
            .catch((error) => {
                subscriber.error(error);
            })
    );
};

export const getPossibleParentPositions = () => {
    const {
        sessionSettings: { last_access_token },
    } = store.getState().authReducer;
    const defaultConfig = { ...URLS.departments.getPossibleParentPositions(last_access_token) };
    const config = {
        ...defaultConfig,
        headers: { ...defaultConfig.headers },
        handlerEnabled: true,
    };

    return new Observable(subscriber =>
        axiosInstance(config)
            .then((response) => {
                if (response?.status == 200 && response?.data?.data) {
                    subscriber.next(response.data?.data);
                    subscriber.complete();
                }
            })
            .catch((error) => {
                subscriber.error(error);
            })
    );
};

export const getCompanyDepartmentManagerialPositions = (department_id) => {
    const last_access_token = store.getState().authReducer?.sessionSettings?.last_access_token ?? null;
    const defaultConfig = { ...URLS.departments.getDepartmentManagerialPositions(last_access_token, department_id) };
    const config = {
        ...defaultConfig,
        headers: { ...defaultConfig.headers },
        handlerEnabled: true,
    };

    return new Observable(subscriber =>
        axiosInstance(config)
            .then((response) => {
                if (response?.status == 200 && response?.data?.data) {
                    // store.dispatch(someAction(payload));
                    subscriber.next(response.data?.data);
                    subscriber.complete();
                }
            })
            .catch((error) => {
                subscriber.error(error);
            })
    );
};
export const getCompanyAllDepartmentManagerialPositions = () => {
    const last_access_token = store.getState().authReducer?.sessionSettings?.last_access_token ?? null;
    const defaultConfig = { ...URLS.departments.getCompanyAllDepartmentManagerialPositions(last_access_token) };
    const config = {
        ...defaultConfig,
        headers: { ...defaultConfig.headers },
        handlerEnabled: true,
    };

    return new Observable(subscriber =>
        axiosInstance(config)
            .then((response) => {
                if (response?.status == 200 && response?.data?.data) {
                    // store.dispatch(someAction(payload));
                    subscriber.next(response.data?.data);
                    subscriber.complete();
                }
            })
            .catch((error) => {
                subscriber.error(error);
            })
    );
};
//positions

export const getAllPositions = (companyId = null) => {
    const params = queryString.stringify(
        { company_id: companyId },
        {
            skipNull: true,
            skipEmptyString: true,
        }
    );

    const last_access_token = store.getState().authReducer?.sessionSettings?.last_access_token ?? null;

    const config = {
        ...URLS.positions.getAllPositions(last_access_token, params),

        handlerEnabled: true,
        forwardAllErrors: true,
        refreshOrgChart: true,
    };

    return new Observable(subscriber =>
        axiosInstance(config)
            .then((response) => {
                if (response?.data && response?.data?.data) {
                    const pos = response?.data?.data;

                    pos.length === 1 &&
                        store.dispatch(
                            setPositionInfo({
                                name: pos?.name,
                                results: pos?.results,
                                strategic: pos?.strategic,
                                tactical: pos?.tactical,
                                standards: pos?.standards,
                                resources: pos?.resources,
                                accountability: pos?.accountability,
                                success: pos?.success,
                                failure: pos?.failure,
                                id: pos?.id,
                                parent_id: pos?.parent_position?.id ? pos.parent_position.id : pos.parent_id,
                                parent_position: pos?.parent_position,
                                department_id: pos.department_id,
                                is_managerial: pos.is_managerial,
                                can_invite_colleagues_into_their_team: pos.can_invite_colleagues_into_their_team,
                                can_remove_colleagues_from_their_team: pos.can_remove_colleagues_from_their_team,
                                users: pos.users,
                                shared_users: pos.shared_users,
                                children: pos.children,
                            })
                        );
                    subscriber.next(pos);
                    subscriber.complete();
                }
            })
            .catch((error) => {
                subscriber.error(error);
            })
    );
};
export const createNewPosition = (positionData) => {
    const last_access_token = store.getState().authReducer?.sessionSettings?.last_access_token ?? null;
    var data = new FormData();

    data.append('name', positionData.name);
    data.append('parent_id', positionData.parent_id);
    data.append('department_id', positionData.department_id);
    data.append('is_managerial', positionData.is_managerial);
    data.append('can_invite_colleagues_into_their_team', positionData.can_invite_colleagues_into_their_team);
    data.append('can_remove_colleagues_from_their_team', positionData.can_remove_colleagues_from_their_team);
    const config = {
        ...URLS.positions.createNewPosition(last_access_token),
        data: data,
        handlerEnabled: true,
        forwardAllErrors: true,
        refreshOrgChart: true,
    };

    return new Observable(subscriber =>
        axiosInstance(config)
            .then((response) => {
                if (response?.data && response?.data?.data) {
                    const pos = response?.data?.data;

                    store.dispatch(
                        setPositionInfo({
                            name: pos?.name || '',
                            results: pos?.results || '',
                            strategic: pos?.strategic || '',
                            tactical: pos?.tactical || '',
                            standards: pos?.standards || '',
                            resources: pos?.resources || '',
                            accountability: pos?.accountability || '',
                            success: pos?.success || '',
                            failure: pos?.failure || '',
                            id: pos?.id,
                            parent_id: pos?.parent_position?.id ? pos.parent_position.id : pos.parent_id,
                            parent_position: pos?.parent_position,
                            department_id: pos.department_id,
                            is_managerial: pos.is_managerial,
                            can_invite_colleagues_into_their_team: pos.can_invite_colleagues_into_their_team,
                            can_remove_colleagues_from_their_team: pos.can_remove_colleagues_from_their_team,
                            users: pos.profiles,
                            shared_users: pos.shared_profiles,
                            children: pos.children,
                        })
                    );
                    subscriber.next(pos);
                    subscriber.complete();
                }
            })
            .catch((error) => {
                subscriber.error(error);
            })
    );
};
export const deletePosition_AndKeepChildren = (positionId) => {
    const last_access_token = store.getState().authReducer?.sessionSettings?.last_access_token ?? null;
    const config = {
        ...URLS.positions.deletePositionAndKeepChildren(last_access_token, positionId),
        handlerEnabled: true,
        //withModalOutput: true,
        refreshOrgChart: true,
        forwardAllErrors: true,
    };

    return new Observable(subscriber =>
        axiosInstance(config)
            .then((response) => {
                if (response?.data) {
                    store.dispatch(setPositionInfo({...positionInfoDefault}));
                    subscriber.next(response?.data);
                    subscriber.complete();
                }
            })
            .catch((error) => {
                subscriber.error(error);
            })
    );
};
export const deletePosition_AndItsChildren = (positionId) => {
    const last_access_token = store.getState().authReducer?.sessionSettings?.last_access_token ?? null;
    const config = {
        ...URLS.positions.deletePositionAndItsChildren(last_access_token, positionId),
        handlerEnabled: true,
        //withModalOutput: true,
        refreshOrgChart: true,
        forwardAllErrors: true,
    };

    return new Observable(subscriber =>
        axiosInstance(config)
            .then((response) => {
                if (response?.data) {
                    store.dispatch(setPositionInfo({...positionInfoDefault}));
                    subscriber.next('success');
                    subscriber.complete();
                }
            })
            .catch((error) => {
                subscriber.error(error);
            })
    );
};

export const updatePosition = (positionId) => {
    const last_access_token = store.getState().authReducer?.sessionSettings?.last_access_token ?? null;
    const { positionInfo } = store.getState().flowReducer;

    const data = {
        name: positionInfo.name,
        results: positionInfo.results, //.replace('~', '\n'),
        strategic: positionInfo.strategic, //.replace('~', '\n'),
        tactical: positionInfo.tactical, //.replace('~', '\n'),
        standards: positionInfo.standards, //.replace('~', '\n'),
        resources: positionInfo.resources, //.replace('~', '\n'),
        accountability: positionInfo.accountability, //.replace('~', '\n'),
        success: positionInfo.success, //.replace('~', '\n'),
        failure: positionInfo.failure, //.replace('~', '\n')
        is_managerial: positionInfo.is_managerial,
        is_department_root: positionInfo.is_department_root,
        is_protected: positionInfo.is_protected,
        parent_id: positionInfo.parent_id,
        department_id: positionInfo.department_id,
        can_invite_colleagues_into_their_team: positionInfo.is_managerial && positionInfo.can_invite_colleagues_into_their_team ? 1 : 0,
        can_remove_colleagues_from_their_team: positionInfo.is_managerial && positionInfo.can_remove_colleagues_from_their_team ? 1 : 0,
    };
    const config = {
        ...URLS.positions.updatePositionById(last_access_token, positionId),
        data: data,
        handlerEnabled: true,
        refreshOrgChart: true,
    };

    return new Observable(subscriber =>
        axiosInstance(config)
            .then((response) => {
                if (response.status == '200' && response?.data) {
                    store.dispatch(setPositionInfo({...positionInfoDefault}));
                    subscriber.next('success');
                    subscriber.complete();
                }
            })
            .catch((error) => {
                subscriber.error(error);
            })
    );
};
export const getPositionById = (positionId) => {
    const {
        sessionSettings: {last_access_token},
    } = store.getState().authReducer;

    const config = {
        ...URLS.positions.getPositionById(last_access_token, positionId),
        handlerEnabled: true,
    };

    return new Observable(async (subscriber) => {
        try {
            const response = await axiosInstance(config);

            if (response.status === 200 && response.data) {
                const pos = response.data.data;
                let position_info = {
                    name: pos?.name || '',
                    results: pos?.results || '',
                    strategic: pos?.strategic || '',
                    tactical: pos?.tactical || '',
                    standards: pos?.standards || '',
                    resources: pos?.resources || '',
                    accountability: pos?.accountability || '',
                    success: pos?.success || '',
                    failure: pos?.failure || '',
                    id: pos?.id,
                    parent_id: pos?.parent_position?.id ? pos.parent_position.id : pos.parent_id,
                    parent_position: pos.parent_position,
                    department_id: pos.department_id,
                    is_managerial: pos.is_managerial,
                    is_department_root: pos.is_department_root,
                    is_protected: pos.is_protected,
                    children: pos.children,
                    users: pos.profiles,
                    shared_users: pos.shared_profiles,
                    can_invite_colleagues_into_their_team: pos.can_invite_colleagues_into_their_team,
                    can_remove_colleagues_from_their_team: pos.can_remove_colleagues_from_their_team,
                    is_managed_by_current_user: pos.is_managed_by_current_user,
                };

                //Needed for getting parent `is_department_root` field Maybe in future it's better to ask BE to provide this variable in main response
                if (position_info.parent_id) {
                    const newResponse = await axiosInstance({
                        ...URLS.positions.getPositionById(last_access_token, position_info.parent_id),
                        handlerEnabled: true,
                    });

                    if (newResponse.status === 200 && newResponse.data) {
                        const parentResponse = newResponse.data.data;

                        position_info.parent_position = {
                            ...position_info.parent_position,
                            is_department_root: parentResponse.is_department_root,
                        };
                    }
                }
                store.dispatch(setPositionInfo(position_info));
                subscriber.next(pos);
                subscriber.complete();
            }
        } catch (error) {
            subscriber.error(error);
        }
    });
};
export const getSpecificPositionUsers = (positionId) => {
    const last_access_token = store.getState().authReducer?.sessionSettings?.last_access_token ?? null;
    const config = {
        ...URLS.positions.getPositionUsers(last_access_token, positionId),
        handlerEnabled: true,
        //withModalOutput: true,
    };

    return new Observable(subscriber =>
        axiosInstance(config)
            .then((response) => {
                if (response.status === '200' && response?.data) {
                    subscriber.next(response?.data?.data);
                    subscriber.complete();
                }
            })
            .catch((error) => {
                subscriber.error(error);
            })
    );
};
export const duplicateSpecificPosition = (positionId, name, parent_id = '') => {
    const last_access_token = store.getState().authReducer?.sessionSettings?.last_access_token ?? null;
    var data = new FormData();

    data.append('name', name);
    parent_id.length > 0 && data.append('parent_id', parent_id);
    const config = {
        ...URLS.positions.duplicatePosition(last_access_token, positionId),
        data: data,
        handlerEnabled: true,
        //withModalOutput: true,
        refreshOrgChart: true,
        forwardAllErrors: true,
    };

    return new Observable(subscriber =>
        axiosInstance(config)
            .then((response) => {
                if (response?.data?.data) {
                    subscriber.next(response?.data?.data);
                    subscriber.complete();
                }
            })
            .catch((error) => {
                subscriber.error(error);
            })
    );
};
export const addingUserToPosition = (positionId, selectedToAdd) => {
    const last_access_token = store.getState().authReducer?.sessionSettings?.last_access_token ?? null;
    const data = new FormData();

    for (let i = 0; i < selectedToAdd.length; i++) {
        data.append('user_id[]', selectedToAdd[i].value);
    }

    const config = {
        ...URLS.positions.addUserToPosition(last_access_token, positionId, data),
        handlerEnabled: true,
        forwardAllErrors: true,
        retrieveAuthenticatedUser: true};

    return new Observable(subscriber =>
        axiosInstance(config)
            .then((response) => {
                if (response?.status === 200 && response.data.data) {
                    subscriber.next(response.data.data);
                    subscriber.complete();
                }
            })
            .catch((error) => {
                subscriber.error(error);
            })
    );
};
export const removeUserFromPosition = (positionId, userId) => {
    const last_access_token = store.getState().authReducer?.sessionSettings?.last_access_token ?? null;
    const data = qsSimple.stringify({ user_id: [userId] });

    const config = {
        ...URLS.positions.deleteUserFromPosition(last_access_token, positionId, data),
        handlerEnabled: true,
        forwardAllErrors: true,
        retrieveAuthenticatedUser: true,
    };

    return new Observable(subscriber =>
        axiosInstance(config)
            .then((response) => {
                if (response?.status === 200) {
                    subscriber.next(response);
                    subscriber.complete();
                }
            })
            .catch((error) => {
                subscriber.error(error);
            })
    );
};
export const sharingUserToPosition = (positionId, userIds) => {
    const last_access_token = store.getState().authReducer?.sessionSettings?.last_access_token ?? null;
    const data = new FormData();

    data.append('user_ids', [userIds]);
    const config = {
        ...URLS.positions.shareUserToPosition(last_access_token, positionId, { user_ids: userIds }),
        handlerEnabled: true,
    };

    return new Observable(subscriber =>
        axiosInstance(config)
            .then((response) => {
                subscriber.next(response?.data?.message);
            })
            .catch((error) => {
                subscriber.error(error);
            })
    );
};
export const unsharingUserFromPosition = (positionId, userIds = []) => {
    const last_access_token = store.getState().authReducer?.sessionSettings?.last_access_token ?? null;
    const data = qsSimple.stringify({ user_ids: [...userIds] });
    const config = {
        ...URLS.positions.unshareUserFromPosition(last_access_token, positionId, data),
        handlerEnabled: true,
    };

    return new Observable(subscriber =>
        axiosInstance(config)
            .then((response) => {
                if (response?.status === 200 && response?.data) {
                    getPositionById(positionId).subscribe({
                        complete: () => {
                            subscriber.next(response.data);
                            subscriber.complete();
                        },
                    });
                }
            })
            .catch((error) => {
                subscriber.error(error);
            })
    );
};


export const deactivateCompany = (company_id) => {
    const {
        sessionSettings: { last_access_token},
    } = store.getState().authReducer;

    const config = {
        ...URLS.company.deactivateCompany(last_access_token, company_id),
        handlerEnabled: true,
        forwardAllErrors: true,
    };

    return new Observable(subscriber =>
        axiosInstance(config)
            .then((response) => {
                if (response?.data) {
                    subscriber.next(response.data);
                    subscriber.complete();
                }
            })
            .catch((error) => {
                subscriber.error(error);
            })
    );
};

export const pauseCompanySubscription = (company_id, resumeAt) => {
    const {
        sessionSettings: { last_access_token},
    } = store.getState().authReducer;

    const data = qsSimple.stringify({ resumes_at: resumeAt, immediately: true });

    const config = {
        ...URLS.company.pauseSubscription(last_access_token, company_id, data),
        handlerEnabled: true,
        forwardAllErrors: true,
    };

    return new Observable(subscriber =>
        axiosInstance(config)
            .then((response) => {
                if (response?.data) {
                    subscriber.next(response.data);
                    subscriber.complete();
                }
            })
            .catch((error) => {
                subscriber.error(error);
            })
    );
};

export const resumeCompanySubscription = (company_id) => {
    const {
        sessionSettings: { last_access_token},
    } = store.getState().authReducer;

    const config = {
        ...URLS.company.resumeSubscription(last_access_token, company_id),
        handlerEnabled: true,
        forwardAllErrors: true,
    };

    return new Observable(subscriber =>
        axiosInstance(config)
            .then((response) => {
                if (response?.data) {
                    subscriber.next(response.data);
                    subscriber.complete();
                }
            })
            .catch((error) => {
                subscriber.error(error);
            })
    );
};

export const purchaseSubscription = (company_id, service_details) => {
    const {
        sessionSettings: { last_access_token},
    } = store.getState().authReducer;

    const data = qsSimple.stringify(service_details);

    const config = {
        ...URLS.company.purchaseSubscription(last_access_token, company_id, data),
        handlerEnabled: true,
        forwardAllErrors: true,
    };


    return new Observable(subscriber =>
        axiosInstance(config)
            .then((response) => {
                if (response?.data) {
                    subscriber.next(response.data);
                    subscriber.complete();
                }
            })
            .catch((error) => {
                subscriber.error(error);
            })
    );
};


